import React, { useEffect } from "react";
import About from "../../components/About/About";
import Education from "../../components/Education/Education";
import Experience from "../../components/Experience/Experience";
import Interests from "../../components/Interests/Interests";
import Profile from "../../components/Profile/Profile";
import Other from "../../components/Projects/Other";
import Projects from "../../components/Projects/Projects";
import SoftSkills from "../../components/SoftSkills/SoftSkills";
import TechnicalSkills from "../../components/TechnicalSkills/TechnicalSkills";
import styles from "./form.module.css";
import { createPost, getSubmit } from "../../utils/Fetch/fetch";
import { getLocal, setLocal } from "../../utils/Local/local";
import Language from "../../components/Language/Language";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Accomplishment from "../../components/Accomplishments/Accomplishment";
import MadeBy from "../../components/MadeBy/MadeBy";

const Form = () => {
  const navigate = useNavigate();
  let LocalID = getLocal("resume_builder") || undefined;
  useEffect(() => {
    const myFn = async () => {
      if (LocalID === undefined || LocalID.length < 24) {
        let data = await createPost();
        setLocal("resume_builder", data.resume._id);
        console.log("data", data);
      }
    };
    myFn();
  }, []);

  const handleSubmit = async () => {
    let getOneData = await getSubmit();
    if (getOneData === true) {
      toast("Congrats you data has been saved");
      navigate("/resume");
    } else {
      toast(getOneData);
    }
  };

  const handleCopy = () => {
    let text = getLocal("resume_builder");
    navigator.clipboard.writeText(text);
    var tooltip = document.getElementById("myTooltip");
    tooltip.innerHTML = "Copied";
  };

  const showCopyClipText = () => {
    var tooltip = document.getElementById("myTooltip");
    tooltip.innerHTML = "Copy to clipboard";
  };

  return (
    <div className={styles.form__container}>
      <nav>
        <h1 className={styles.resume__logo}>Resume Builder</h1>
        <h4 className={styles.resume__text}>
          Please Fill All The Required Data
        </h4>

        <div className={styles.livecheck__box}>
          For preview copy below ID and{" "}
          <a
            rel="noreferrer"
            className={styles.visit}
            href="https://resume-builder-view.vercel.app/"
            target="_blank"
          >
            visit here
          </a>{" "}
          to paste
          <br />
          <div className={styles.tooltip} style={{ marginTop: "5px" }}>
            <button onClick={handleCopy} onMouseOut={showCopyClipText}>
              <span className={styles.tooltiptext} id="myTooltip">
                Copy to clipboard
              </span>
              Click here to Copy
            </button>
          </div>
        </div>
      </nav>

      <ToastContainer />

      <Profile />
      <About />
      <TechnicalSkills />
      <SoftSkills />
      <Education />
      <Experience />
      <Interests />
      <Projects />
      <Other />
      <Language />
      <Accomplishment />
      <div>
        <button onClick={handleSubmit}>Submit</button>
      </div>

      <MadeBy />
    </div>
  );
};

export default Form;
